
export class SystemStatusResult{

    constructor(public iotHub: string,
        public systemGuid: string,
        public systemStatus: string) {
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/sentienceDeviceManager/system-status-result.ts
 **/